// extracted by mini-css-extract-plugin
export default {"cls1":"ZJRpFBlCYKrTXeEYAT__","cls2":"A8Ym2ZdYo128pkyLNxQY ZJRpFBlCYKrTXeEYAT__"};